import { radius } from "component_library/styles/theme"
import { ButtonCornerStyle } from "website_script/types/theme"

export function getBorderRadiusFromCornerStyle(
    buttonCornerStyle: ButtonCornerStyle
  ) {
    switch (buttonCornerStyle) {
      case ButtonCornerStyle.SLIGHTLY_ROUNDED:
        return radius.small
      case ButtonCornerStyle.ROUNDED:
        return radius.medium
      case ButtonCornerStyle.FULLY_ROUNDED:
        return radius.full
      case ButtonCornerStyle.SHARP:
      default:
        return radius.sharp
    }
  }